class UserSettings {

  constructor(
    $translate,
    $q,
    authService,
    courseService,
    helperService,
    userService
  ) {
    'ngInject';

    Object.assign(this, {
      $translate,
      $q,
      authService,
      courseService,
      helperService,
      userService
    });

  }

  submit() {
    this.response = null;

    const oldPassword = this.oldPassword;
    const newPassword = this.newPassword;
    const confirmNewPassword = this.confirmNewPassword;

    this.userService.resetPassword(oldPassword, newPassword, confirmNewPassword)
      .then(data => {
        this.response = data;
      })
  }


}

export default UserSettings;


// WEBPACK FOOTER //
// ./client/app/modules/userSettings/userSettings.controller.js